// Medaillenspiegel.jsx — Gold/Silber/Bronze je Verein (V5, 18.10.2026)
//
// Gemeinsam für das ErgebnisDashboard (intern) und die öffentliche
// Ergebnisseite /turnier/:id/ergebnisse. Gerechnet wird im Backend
// (utils/medaillenspiegel.js): alle Disziplinen, Teamformen ein Platz je Team.
// Farben erbt die Tabelle vom umgebenden Bereich, damit sie in hell und
// dunkel passt.
import React, { useEffect, useState } from 'react';
import './Medaillenspiegel.css';

const DISZIPLIN = { formen: 'Formen', kampf: 'Kampf', bruchtest: 'Bruchtest' };

export default function Medaillenspiegel({ turnierId, titel = 'Medaillenspiegel' }) {
  const [daten, setDaten] = useState(null);
  const [fehler, setFehler] = useState('');

  useEffect(() => {
    if (!turnierId) return undefined;
    let aus = false;
    (async () => {
      try {
        const token = localStorage.getItem('token');
        const r = await fetch(`/api/siegerehrung/turnier/${turnierId}/public/medaillenspiegel`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        const d = await r.json().catch(() => ({}));
        if (!r.ok || !d.success) throw new Error(d.error || `HTTP ${r.status}`);
        if (!aus) { setDaten(d); setFehler(''); }
      } catch (e) {
        if (!aus) setFehler(e.message);
      }
    })();
    return () => { aus = true; };
  }, [turnierId]);

  if (fehler) return <p className="msp-hinweis msp-fehler">Medaillenspiegel nicht ladbar: {fehler}</p>;
  if (!daten) return <p className="msp-hinweis">Medaillenspiegel wird geladen …</p>;
  if (!daten.data.length) return <p className="msp-hinweis">Noch keine Medaillen vergeben.</p>;

  const summe = daten.data.reduce((s, v) => ({ g: s.g + v.gold, s: s.s + v.silber, b: s.b + v.bronze }), { g: 0, s: 0, b: 0 });

  return (
    <section className="msp" aria-label={titel}>
      <h2 className="msp-titel">{titel}</h2>
      <p className="msp-hinweis">
        Je Verein, alle Disziplinen ({daten.disziplinen.map((d) => DISZIPLIN[d] || d).join(', ')}). Teamformen zählen einmal je Team.
      </p>
      <div className="msp-rahmen">
        <table className="msp-tabelle">
          <thead>
            <tr>
              <th scope="col" className="msp-rang">Rang</th>
              <th scope="col">Verein</th>
              <th scope="col" className="msp-zahl"><span className="msp-punkt msp-gold" aria-hidden="true" />Gold</th>
              <th scope="col" className="msp-zahl"><span className="msp-punkt msp-silber" aria-hidden="true" />Silber</th>
              <th scope="col" className="msp-zahl"><span className="msp-punkt msp-bronze" aria-hidden="true" />Bronze</th>
              <th scope="col" className="msp-zahl">Gesamt</th>
            </tr>
          </thead>
          <tbody>
            {daten.data.map((v) => (
              <tr key={v.verein_name}>
                <td className="msp-rang">{v.rang ? `${v.rang}.` : '–'}</td>
                <td className="msp-verein">{v.verein_name}</td>
                <td className="msp-zahl">{v.gold}</td>
                <td className="msp-zahl">{v.silber}</td>
                <td className="msp-zahl">{v.bronze}</td>
                <td className="msp-zahl msp-gesamt">{v.gesamt}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td />
              <td>Summe</td>
              <td className="msp-zahl">{summe.g}</td>
              <td className="msp-zahl">{summe.s}</td>
              <td className="msp-zahl">{summe.b}</td>
              <td className="msp-zahl msp-gesamt">{summe.g + summe.s + summe.b}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </section>
  );
}
